<template>
  <UiCard>
    <div slot="title">
      <div class="title">Доступы</div>
    </div>

    <div slot="content">
      <div class="row two-columns between-xs">
        <div v-for="(field, index) in accessFields" :key="index" class="form-group">
          <AccessField v-model="acceses[field.key]" v-bind="field.attrs" />
        </div>
      </div>
    </div>

    <div slot="footer">
      <UiButton
        :disabled="trySaveManagerAccesses"
        :class="['button', 'is-blue', { 'is-loading': trySaveManagerAccesses }]"
        @click="updateManagerAccesses"
      >
        Сохранить
      </UiButton>
    </div>
  </UiCard>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import AccessField from './AccessField.vue'

import { mapGetters } from 'vuex'

import accessFields from './accessFields.js'

import { ManagersService } from '@/services/managers.service'

export default {
  components: { UiCard, AccessField, UiButton },
  mixins: [accessFields],
  data() {
    return {
      trySaveManagerAccesses: false,

      acceses: {
        applications: '',
        managers: '',
        finances: '',
        logs: '',
        payments: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      manager: 'managers/manager',
      managerAccesses: 'managers/managerAccesses',
    }),
  },
  watch: {
    managerAccesses: {
      handler: 'margeAcceses',
    },
  },
  methods: {
    margeAcceses(accesses) {
      this.acceses = { ...accesses }
    },
    /**
     * Send request to backend for update manager accesses.
     *
     * @returns {void}
     * */
    async updateManagerAccesses() {
      this.trySaveManagerAccesses = true
      try {
        const id = this.manager.id
        const payload = this.acceses
        await ManagersService.updateAbilities({ id, payload })
        this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      } finally {
        this.trySaveManagerAccesses = false
      }
    },
  },
}
</script>
